import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import HelpPanel from '../../../../components/common/HelpPanel';

const HealthLayout: React.FC = () => {
  const [showHelpPanel, setShowHelpPanel] = useState(false);

  return (
    <div>
      {/* Health Content - No header to avoid double title */}
      <Outlet />

      {/* Help Panel */}
      <HelpPanel
        isOpen={showHelpPanel}
        onClose={() => setShowHelpPanel(false)}
        title="Health Dashboard Help"
      >
        <div className="prose dark:prose-invert max-w-none">
          <h3>About Health Dashboard</h3>
          <p>
            The Health Dashboard provides a comprehensive overview of project delivery health,
            infrastructure budget utilization, and support metrics across all clients you have access to.
          </p>

          <h4>Key Metrics</h4>
          <ul>
            <li><strong>On-Time Delivery Rate:</strong> Percentage of projects on track (green health status)</li>
            <li><strong>Projects Behind Schedule:</strong> Count of projects at risk (yellow/red status)</li>
            <li><strong>Budget Burn Rate:</strong> Overall infrastructure budget utilization percentage</li>
            <li><strong>Pending Support:</strong> Number of open/pending support requests</li>
          </ul>

          <h4>Project Health Heatmap</h4>
          <p>
            The treemap visualization shows all projects sized by infrastructure budget.
            Colors indicate health status:
          </p>
          <ul>
            <li><strong>Green:</strong> On track (progress matches timeline)</li>
            <li><strong>Yellow:</strong> At risk (10-25% behind schedule)</li>
            <li><strong>Red:</strong> Off track (25%+ behind schedule)</li>
          </ul>

          <h4>Budget Health</h4>
          <p>
            Monitor infrastructure spending and identify projects that are approaching or
            exceeding their budgets. Budget alerts highlight projects at 80%+ utilization.
          </p>

          <h4>Cross-Client View</h4>
          <p>
            All metrics show data across all clients you have access to, regardless of
            the client selected in the navigation bar. This provides a holistic view of
            overall health.
          </p>
        </div>
      </HelpPanel>
    </div>
  );
};

export default HealthLayout;
